module.exports = __webpack_public_path__ + "img/30000.89035479.jpg";